var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import SecondaryNavLayout from "../../src/View/Layout/SecondaryNavLayout";
import usePagedSortedTable, { TotalPageMappers, } from "../../src/View/Hooks/usePagedSortedTable";
import DateService from "../../src/Services/Shared/Date.service";
import { InlineFormFormat } from "../../src/View/UI/FormFormat/FormFormat";
import SurveyResponseService from "../../src/Services/SurveyResponse.service";
import { getSurveyAdminDetailsPath } from "../../src/View/Pages/Admin/Survey/AdminSurveyRoutes";
import { PersonMultiSearch } from "../../src/View/Presentational/Person/PersonSearch";
import SearchField from "../../src/View/Form/SearchField";
import { SurveyMultiSearch } from "../../src/View/Presentational/Survey/SurveySearch";
import useCheckboxes from "../../src/View/Hooks/useCheckboxes";
import SecondaryNavButton from "../../src/View/UI/SecondaryNav/SecondaryNavButton";
import useService from "../../src/View/Hooks/useService";
import { ItemStatusMultiSearch } from "../../src/View/Presentational/ItemStatus/ItemStatusSearch";
const PAGE_SIZE = 25;
const SurveyResponseAdmin = () => {
    const { getCheckbox, checkedItems } = useCheckboxes({
        externallyCheckedItems: [],
        // eslint-disable-next-line eqeqeq
        equalsFunc: (a, b) => a.id == b.id,
    });
    const [searchArgs, setSearchArgs] = React.useState({});
    const { table, refresh } = usePagedSortedTable({
        searchArgs,
        hover: true,
        striped: true,
        noDataComponent: "No survey responses were found.",
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'PagedResult<any>'.
        getNumPages: (re) => TotalPageMappers.EngagePagedResult(re, PAGE_SIZE),
        getData: (sort, pageNumber, sArgs) => {
            return SurveyResponseService.search(Object.assign({}, sArgs), {
                max: PAGE_SIZE,
                offset: pageNumber * PAGE_SIZE,
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: (sort === null || sort === void 0 ? void 0 : sort.order) === "asc" ? "ascnullsfirst" : "descnullslast",
            });
        },
        columns: [
            { title: "Survey", sortId: "SURVEYRESPONSE_SURVEY" },
            { title: "Sender", sortId: "SURVEYRESPONSE_SENDER" },
            { title: "Recipient", sortId: "SURVEYRESPONSE_RECIPIENT" },
            { title: "Created Date", sortId: "SURVEYRESPONSE_CREATEDDATE" },
            { title: "Status", sortId: "SURVEYRESPONSE_STATUSID" },
            { title: "Status Change Date", sortId: "SURVEYRESPONSE_STATUSDATE" },
        ],
        addCheckboxes: {
            useCheckboxesMakeCheckbox: getCheckbox,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            getCheckedItem: (data, index) => data.data[index],
        },
        // @ts-expect-error - TS2322 - Type '({ data }: { data: any; }) => any' is not assignable to type 'Node[][] & ((arg1: unknown) => Node[][])'.
        rows: ({ data }) => data.map((surveyResponse) => [
            _jsx(Link, { to: getSurveyAdminDetailsPath(surveyResponse.survey.id), children: surveyResponse.survey.displayName }, surveyResponse.id),
            surveyResponse.sender.fullName,
            surveyResponse.recipient.fullName,
            DateService.displayWithTime(surveyResponse.createdDate),
            surveyResponse.status.name,
            surveyResponse.statusDate &&
                DateService.displayWithTime(surveyResponse.statusDate),
        ]),
    });
    const [deleteSurveyResponsesState, deleteSurveyResponses] = useService(SurveyResponseService.deleteSurveyResponses);
    return (_jsx(SecondaryNavLayout, { nav: _jsx(SecondaryNavButton, { icon: "trash-alt", label: "Delete", title: "Delete", confirmMessage: "Are you sure you want to delete these survey status(es)?", onClickWithLoader: () => checkedItems.length > 0
                ? deleteSurveyResponses(checkedItems).then(() => refresh())
                : Promise.reject("No checked surveys") }), dontAddSpacer: true, children: _jsxs("div", { className: "container-fluid pb-5 mt-3", children: [_jsx("div", { className: "title-block clearfix", children: _jsx("h1", { className: "title", children: "Surveys Status" }) }), _jsxs("div", { children: [_jsxs(InlineFormFormat, { saveButtonContents: "Search", handleSubmit: (surveyState) => __awaiter(void 0, void 0, void 0, function* () {
                                var _a, _b, _c, _d;
                                setSearchArgs({
                                    statusIds: (_a = surveyState.statusIds) === null || _a === void 0 ? void 0 : _a.map((status) => status.id),
                                    senderIds: (_b = surveyState.senderIds) === null || _b === void 0 ? void 0 : _b.map((person) => person.personId),
                                    surveyIds: (_c = surveyState.surveyIds) === null || _c === void 0 ? void 0 : _c.map((survey) => survey.id),
                                    recipientIds: (_d = surveyState.recipientIds) === null || _d === void 0 ? void 0 : _d.map((person) => person.personId),
                                });
                            }), children: [_jsx(SearchField, { label: "Sender", name: "senderIds", as: (provided) => (_jsx(PersonMultiSearch, Object.assign({ lookupModal: {
                                            isInModal: false,
                                        }, noOptionsMessage: ({ inputValue }) => {
                                            return "No Options";
                                        } }, provided))) }), _jsx(SearchField, { label: "Recipient", name: "recipientIds", as: (provided) => (_jsx(PersonMultiSearch, Object.assign({ lookupModal: {
                                            isInModal: false,
                                        }, noOptionsMessage: ({ inputValue }) => {
                                            return "No Options";
                                        } }, provided))) }), _jsx(SearchField, { label: "Survey", name: "surveyIds", as: (provided) => (_jsx(SurveyMultiSearch, Object.assign({ lookupModal: {
                                            isInModal: false,
                                        }, noOptionsMessage: ({ inputValue }) => {
                                            return "No Options";
                                        } }, provided))) }), _jsx(SearchField, { label: "Statuses", name: "statusIds", as: (provided) => (_jsx(ItemStatusMultiSearch, Object.assign({ activityItemTypeIds: [5], lookupModal: {
                                            isInModal: false,
                                        }, noOptionsMessage: ({ inputValue }) => {
                                            return "No Options";
                                        } }, provided))) })] }), _jsx("div", { className: "mt-3", children: table })] })] }) }));
};
export default SurveyResponseAdmin;
